module.exports = __webpack_public_path__ + "static/media/imp_note.ed661fa9.svg";